import type { AdminCrewReportCheckboxProps } from "../../models/admin-crew-report.models";
import { CheckIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

const AdminCrewReportCheckbox = ({
  checked,
  disabled,
  id,
  ariaLabel,
  dataTest,
  className,
  onChange,
  onClick,
  onKeyDown,
}: AdminCrewReportCheckboxProps) => (
  <span
    data-testid={dataTest ? `${dataTest}-container` : undefined}
    className={twMerge("relative block h-4 w-4 flex-none", className)}
  >
    <input
      id={id}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      aria-label={ariaLabel}
      data-test={dataTest}
      className="peer absolute inset-0 z-10 m-0 h-4 w-4 cursor-pointer appearance-none border-0 bg-transparent p-0 opacity-0 focus:outline-none disabled:cursor-not-allowed"
      onChange={onChange}
      onClick={onClick}
      onKeyDown={onKeyDown}
    />
    <span
      aria-hidden="true"
      data-testid={dataTest ? `${dataTest}-visual` : undefined}
      className={twMerge(
        "pointer-events-none absolute inset-0 box-border block h-4 w-4 rounded border border-[#8AA6A1] bg-white text-white peer-focus-visible:ring-2 peer-focus-visible:ring-green dark:bg-gray-800",
        checked && "border-green bg-green dark:border-green dark:bg-green",
        disabled && "opacity-60",
      )}
    >
      {checked ? (
        <CheckIcon
          data-testid={dataTest ? `${dataTest}-tick` : undefined}
          className="absolute inset-0 m-auto h-3 w-3 stroke-[3]"
        />
      ) : null}
    </span>
  </span>
);

export default AdminCrewReportCheckbox;
